<template>
  <div class="root">
    <div class="header">
      <img v-lazy="require('../../assets/imgs/iphone_head_back.png')" />
      <el-row class="headermenu">
        <el-col :span="8"><a @click="choosencomp(1, $event)" :class="whichcomp == 'ldt' ? 'active' : ''">朗读亭</a></el-col>
        <el-col :span="8"><a @click="choosencomp(2, $event)" :class="whichcomp == 'msp' ? 'active' : ''">电子墨水屏</a></el-col>
        <el-col :span="8"><a @click="choosencomp(3, $event)" :class="whichcomp == 'room' ? 'active' : ''">智慧阅览室</a></el-col>
      </el-row>
    </div>
    <component :is="whichcomp"></component>
    <div class="footer">
      <el-row>
        <el-col :span="2">&nbsp;</el-col>
        <el-col :span="20" class="title">
          <img src="../../assets/imgs/iphone_ldttitle6.png" class="titleimg" />
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="1">&nbsp;</el-col>
        <el-col :span="22" class="footer_detail">
          <p>
            <span class="footer_title">电话：</span>
            <span class="footer_data">18510005207 （微信同号）</span>
          </p>
          <p>
            <span class="footer_title">邮箱：</span>
            <span class="footer_data">2235088075@qq.com</span>
          </p>
          <p>
            <span class="footer_title">网址： </span>
            <span class="footer_data">www.zbxingzhi.cn</span>
          </p>
          <p>
            <span class="footer_title">地址： </span>
            <span class="footer_data">广州市黄埔区科学大道286号7楼702-1房</span>
          </p>
          <p>
            <span class="footer_title">备案号： </span>
            <a class="footer_data" target="_blank" href="https://beian.miit.gov.cn/">粤ICP备2023007437号</a>
          </p>
          <img class="flower" v-lazy="require('../../assets/imgs/flower4.png')" />
        </el-col>
        <el-col :span="1">&nbsp;</el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import ldt from "./ldt";
import msp from "./msp";
import room from "./room";
export default {
  name: "iphoneIndex",
  components: {
    ldt,
    msp,
    room
  },
  data () {
    return {
      whichcomp: "ldt",
      components: ["ldt", "msp", 'room']
    };
  },
  created () {
    if (window.location.href.split('?').length > 1) {
      var cs = window.location.href.split('?')[1].split('&');
      if (cs.length > 0) {
        this.whichcomp = cs[0];
      }
    }
  },
  methods: {
    choosencomp (x, e) {
      e = e.currentTarget;
      document.querySelectorAll(".headermenu a").forEach(item => {
        if (item == e) {
          item.classList.add("active");
        } else {
          item.classList.remove("active");
        }
      });
      this.whichcomp = this.components[x - 1];
    }
  }
};
</script>
<style scoped>
.root {
  background-image: url("../../assets/imgs/iphone_back.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
.header {
  width: 100%;
}
.header img {
  width: 100%;
  height: 24vh;
}
.headermenu {
  font-size: 18px;
  margin-top: -3.7vh;
  height: 6vh;
  line-height: 6vh;
  background-color: #ece0cb;
  color: #999999;
  font-weight: bolder;
  font-family: jiangxizhuokai;
}
.headermenu .el-col {
  height: 3.5vh;
  margin-top: 1vh;
  line-height: 3.5vh;
}
.headermenu .el-col:nth-of-type(2) {
  border-right: 2px solid rgba(141, 122, 90, 0.25);
  border-left: 2px solid rgba(141, 122, 90, 0.25);
}
.active {
  padding-bottom: 1.2vh;
  color: black;
  border-bottom: 3px solid #890101;
}
.titleimg {
  width: 100%;
  height: 100%;
}
.title {
  margin-top: 5vh;
  margin-left: 3vw;
  margin-bottom: 5vh;
}
.footer_detail p {
  margin-top: 3vh;
  position: relative;
  z-index: 999;
  text-align: left;
}
.footer_title {
  color: #890000;
  font-weight: bolder;
}
.footer_data {
  font-weight: bolder;
  color: #231815;
}
.flower {
  position: absolute;
  right: -10vw;
  width: 50vw;
  height: 22vh;
  top: 0;
}
.footer {
  padding-bottom: 10vh;
}
</style>



// WEBPACK FOOTER //
// src/components/iphone/index.vue